import { render, staticRenderFns } from "./TargetCard.vue?vue&type=template&id=824acede&"
import script from "./TargetCard.vue?vue&type=script&lang=js&"
export * from "./TargetCard.vue?vue&type=script&lang=js&"
import style0 from "./TargetCard.vue?vue&type=style&index=0&id=824acede&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports